import React, { useState } from 'react';
import { PageTitle } from '@galop/component-library';
import { AppName } from '../Admin/Admin';
import Can from '../Shared/Can';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { InquiryList } from './InquiryList';
import { makeCall } from '../../auth-utils';
import { api } from '../../api/create-api';

const config = {
    resourceName: 'inquiry',
    capitalResourceName: 'Inquiry',
    pluralResourceName: function () {
        return 'inquiries';
    },
    pluralCapitalResourceName: function () {
        return 'Inquiries';
    },
    writeRole: "admin",
    controllerName: 'inquiries',
    listHeader: 'Property Name'
};

export const Inquiries = (props) => {
    const { CurrentUser } = props;
    const [resourceIsDirty, setResourceIsDirty] = useState(false);

    return (
        <div className="d-flex flex-column h-100">
            <PageTitle moduleName={config.pluralCapitalResourceName()} flexBehavior="flex-row" AppName={AppName} />
            <InquiryList {...{ config, CurrentUser, resourceIsDirty, setResourceIsDirty }} />
        </div>
    );
};

export const getInquiries = (preload, loadFullObjects, callback, handleError) => {
    makeCall(async (authHeader) => {
        if (preload && typeof preload === 'function') {
            preload(loadFullObjects);
        }
        const result = await api(`api/${config.controllerName}?loadFullObject=${loadFullObjects}`, {
            headers: authHeader
        })
            .catch(handleError ? handleError : (error) => console.log('error', error));

        if (result && result.data) {
            if (!loadFullObjects) {
                getInquiries(preload, !loadFullObjects, callback, handleError);

                const data = result.data.map(result => ({ ...result, loaded: false }));

                if (callback && typeof callback === 'function') {
                    callback(data);
                }
            }
            else {
                const data = result.data.map(result => ({ ...result, loaded: true }));

                if (callback && typeof callback === 'function') {
                    callback(data);
                }
            }
        }
    });
};

export const deleteInquiry = (preload, id, callback, handleError) => {
    makeCall(async (authHeader) => {
        if (preload && typeof preload === 'function') {
            preload();
        }
        await api.delete(`api/${config.controllerName}/${id}`, {
            headers: authHeader
        }).catch(handleError ? handleError : (error) => console.log('error', error));

        if (callback && typeof callback === 'function') {
            callback();
        }
    });
};




// WEBPACK FOOTER //
// ./src/components/Inquiries/Inquiries.js